import {useState} from "react";
import {useDispatch} from "react-redux";
import {Box, CircularProgress} from "@mui/material";
import _ from "lodash";
import BasicButton from "../../../../common/BasicButton";
import {organizationSettingsService} from "_services";
import {organizationSettingsActions} from "_actions";
import {SnackBar} from "components/common";
import {Auth} from "components/Authorization";

export default function TrendsOnlyDataSourceDetails({trendsHandle, label, organizationId, organizationTrendsId}) {
    const dispatch = useDispatch();
    const [migrating, setMigrating] = useState(false);

    const handleMigrate = async () => {
        if (migrating || trendsHandle?.id == null) {
            return;
        }
        setMigrating(true);
        try {
            await organizationSettingsService.copyTrendsDataSourceHandleToTeams(trendsHandle.id);
            SnackBar.showMessage("Data source migrated to Teams.");
            if (organizationId) {
                dispatch(organizationSettingsActions.refreshDataSourceHandleInfo(organizationId));
            }
            if (organizationTrendsId) {
                dispatch(organizationSettingsActions.fetchTrendsDataSourceHandles(organizationTrendsId));
            }
        } catch (error) {
            if (_.get(error, "response.status") === 401) {
                Auth.processLogout();
                return;
            }
            const message = _.get(error, "response.data.message")
                || _.get(error, "message")
                || "Failed to migrate data source.";
            SnackBar.showMessage(message);
        } finally {
            setMigrating(false);
        }
    };

    const disabled = migrating || trendsHandle?.id == null;

    return (
        <Box sx={styles.container}>
            <BasicButton
                label={migrating ? "Migrating…" : label.MIGRATE_TO_TEAMS}
                action={handleMigrate}
                disabled={disabled}
                endIcon={migrating ? <CircularProgress size={16} sx={styles.spinner} /> : null}
            />
        </Box>
    );
}

const styles = {
    container: {
        maxWidth: '200px',
    },
    spinner: {
        color: '#fff',
    },
};
